var React = require('react');

function ChatInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"stroke":"#FEF1E9","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.1","d":"M1 11a10 10 0 1020 0 10 10 0 00-20 0v0zM9 9h4M9 11.67h4","key":0}),React.createElement("path",{"stroke":"#FEF1E9","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"1.1","d":"M16.33 10.33c0-2.57-2.38-4.66-5.33-4.66-2.94 0-5.33 2.09-5.33 4.66A4.72 4.72 0 009 14.66V17l2.8-2.05a4.91 4.91 0 004.53-4.62z","key":1})]);
}

ChatInline.defaultProps = {"fill":"none","viewBox":"0 0 22 22"};

module.exports = ChatInline;

ChatInline.default = ChatInline;
